// src/components/SignIn.tsx
import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import toast from "react-hot-toast";
import "../styles/App.css";
import { SERVER_URL } from "../config";
import { AuthContext } from "../context/AuthContext";
import ForgotPasswordModal from "./modals/ForgotPasswordModal";

const SignIn: React.FC = () => {
  const navigate = useNavigate();
  const { setToken } = useContext(AuthContext);

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState<boolean>(false);
  const [showReset, setShowReset] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await axios.post(`${SERVER_URL}/api/auth/login`, {
        email,
        password,
      });
      const { token, user } = response.data;

      if (user.role === "PATIENT") {
        toast.error(
          "Access denied: Patient users are not allowed. Please use www.aliviameds.com"
        );
        setLoading(false);
        return;
      }

      // 1) persist to localStorage
      localStorage.setItem("token", token);
      // 2) update Context state → Navbar re-renders immediately
      setToken(token);

      // 3) redirect
      if (user.role === "CLINIC_MANAGER") {
        navigate("/clinic-profile");
      } else if (user.role === "PROVIDER") {
        navigate("/prescriptions");
      } else if (user.role === "ADMIN") {
        navigate("/admin/dashboard");
      }
    } catch (err) {
      setError("Invalid email or password");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="signin-container">
      {error && <p className="error-message">{error}</p>}

      {showReset ? (
        <ForgotPasswordModal onClose={() => setShowReset(false)} />
      ) : (
        <>
          <h2>Sign In</h2>
          <form onSubmit={handleSubmit} className="signin-form">
            <div className="form-group">
              <label htmlFor="email">Email</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <label htmlFor="password">Password</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={loading}
              />
            </div>

            <button type="submit" className="signin-button" disabled={loading}>
              {loading ? "Signing In…" : "Sign In"}
            </button>
          </form>
          <button
            className="forgot-password"
            onClick={() => setShowReset(true)}
            disabled={loading}
          >
            Forgot your password?
          </button>
        </>
      )}
    </div>
  );
};

export default SignIn;
